module.exports = __webpack_public_path__ + "img/tema-1-7.2456f421.svg";